import { Badge, IconButton, Tooltip } from '@ethings/ui-toolkit';
import { Theme } from '@mui/material';
import { SxProps } from '@mui/system';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Icon } from '../icons';

interface Props {
  disabled?: boolean;
  filtersLength: number;
  onFilterClicked: () => void;
  size?: 'small' | 'medium' | 'large';
  sx?: SxProps<Theme>;
}

export const FilterBar: FC<Props> = ({ disabled = false, filtersLength, onFilterClicked: onClickHandler }) => {
  const { t } = useTranslation(['common']);

  return (
    <Badge content={filtersLength} data-testid="filter-counter">
      <Tooltip arrow disableHoverListener={disabled} title={t('common:component.filter.heading')} >
        <IconButton
          color='primary'
          data-testid="filters-button"
          disabled={disabled}
          onClick={onClickHandler}
        >
          <Icon data-testid="filter-icon" icon="FilterIcon" fontSize="small" />
        </IconButton>
      </Tooltip>
    </Badge>
  );
};
